import { render } from "./ModificaPosaContatore.vue?vue&type=template&id=46c37071&scoped=true"
import script from "./ModificaPosaContatore.vue?vue&type=script&lang=js"
export * from "./ModificaPosaContatore.vue?vue&type=script&lang=js"

import "./ModificaPosaContatore.vue?vue&type=style&index=0&id=46c37071&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c37071"]])

export default __exports__